module.exports = __webpack_public_path__ + "fonts/regular.5305072.woff";